module.exports = __webpack_public_path__ + "img/Assasin.jpg";